import { createEntityAdapter } from '@reduxjs/toolkit'
import { IModelPreset } from '../../types/modelPreset'

export const modelPresetsAdapter = createEntityAdapter<IModelPreset>()